import React from 'react';

import Skeleton from '../Skeleton';

import { Container } from './style';

const CardItemSkeleton: React.FC = () => {
  return (
    <Container>
      <Skeleton className="image" />

      <div>
        <Skeleton className="title" />
        <Skeleton className="date" />
        <Skeleton className="buttons" />
      </div>
    </Container>
  );
};

export default CardItemSkeleton;
